<template>
    <UiBanner v-editable="blok" :blok="blok" />
</template>

<script setup>
defineProps({ blok: Object });
</script>

<style lang="postcss" scoped>
.banner {
    @apply font-normal text-[#666] text-left xl:ml-[-7px] text-[15px] leading-[25px] rounded mr-0 mt-[27px] mb-0 px-4 py-2.5 border-2 border-solid border-[#b7ccd8];
}
</style>
